import { useEffect, useMemo } from 'react';

import { InvoiceDocumentDialog } from '~/components/invoices/detailPage/InvoiceDocumentDialog';
import {
  getPrimaryDocuments,
  getSupportingDocuments,
} from '~/components/invoices/detailPage/invoiceDocuments';
import { useInvoicePreview } from '~/data/hooks/useInvoice';
import useInvoiceTickets from '~/data/hooks/useInvoiceTickets';
import { invoiceKindToLabelMap } from '~/data/schemas/invoice';

// Loads the invoice fresh: the row's document links may have expired.
export function InvoiceDocumentFromList({
  invoiceId,
  onClose,
}: {
  invoiceId: string;
  onClose: () => void;
}) {
  const { invoice, error, loading } = useInvoicePreview(invoiceId);
  const { tickets } = useInvoiceTickets(invoiceId);

  const primaryDocuments = useMemo(() => getPrimaryDocuments(invoice), [invoice]);
  const supportingDocuments = useMemo(
    () => getSupportingDocuments(invoice, tickets),
    [invoice, tickets],
  );

  useEffect(() => {
    if (error && !invoice) onClose();
  }, [error, invoice, onClose]);

  return (
    <InvoiceDocumentDialog
      open
      onClose={onClose}
      primaryDocuments={primaryDocuments}
      supportingDocuments={supportingDocuments}
      isLoading={loading || !invoice}
      title={
        invoice
          ? `${invoiceKindToLabelMap.get(invoice.kind)} #${invoice.number}`
          : 'Preview Document'
      }
    />
  );
}
